"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var BurnerProvider_1 = require("../../BurnerProvider");

var Button_1 = __importDefault(require("../../components/Button"));

var Page_1 = __importDefault(require("../../components/Page"));

var LineItem_1 = __importDefault(require("../../components/LineItem"));

var ConfirmPage = function ConfirmPage(_a) {
  var history = _a.history,
      assets = _a.assets,
      actions = _a.actions,
      pluginData = _a.pluginData;

  if (!history.location.state) {
    history.replace('/send');
    return null;
  }

  var _b = react_1.useState(false),
      sending = _b[0],
      setSending = _b[1];

  var _c = history.location.state,
      to = _c.to,
      from = _c.from,
      ether = _c.ether,
      assetId = _c.asset,
      message = _c.message,
      id = _c.id;
  var asset = assets.filter(function (a) {
    return a.id === assetId;
  })[0];

  var send = function send() {
    return __awaiter(_this, void 0, void 0, function () {
      var receipt, redirect, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setSending(true);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            actions.setLoading('Sending...');
            return [4
            /*yield*/
            , asset.send({
              from: from,
              to: to,
              ether: ether,
              message: message
            })];

          case 2:
            receipt = _a.sent();
            actions.setLoading(null);
            redirect = pluginData.sent({
              asset: asset,
              from: from,
              to: to,
              ether: ether,
              message: message,
              receipt: receipt,
              hash: receipt.transactionHash,
              id: id
            });
            history.push(redirect || "/receipt/" + asset.id + "/" + receipt.transactionHash);
            return [3
            /*break*/
            , 4];

          case 3:
            err_1 = _a.sent();
            setSending(false);
            console.error(err_1);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return react_1.default.createElement(Page_1.default, {
    title: "Confirm"
  }, react_1.default.createElement(LineItem_1.default, {
    name: "From",
    value: from
  }), react_1.default.createElement(LineItem_1.default, {
    name: "To",
    value: to
  }), react_1.default.createElement(LineItem_1.default, {
    name: "Amount",
    value: ether + " " + asset.name
  }), message && react_1.default.createElement(LineItem_1.default, {
    name: "Message",
    value: message
  }), react_1.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, react_1.default.createElement(Button_1.default, {
    disabled: sending,
    onClick: send
  }, "Send"), react_1.default.createElement(Button_1.default, {
    disabled: sending,
    onClick: function onClick() {
      return history.goBack();
    }
  }, "Cancel")));
};

exports.default = BurnerProvider_1.withBurner(ConfirmPage);